module.exports = __webpack_public_path__ + "static/tefa-f4ff343985071e5f173d5a064f36fec1.png";